const siteMetadata = {
    title: `1st Erith Scout Group`,
    siteUrl: `http://localhost`,
    capitalizeTitleOnHome: true,
    logo: `/images/branding/scouts-logo-purple.png`,
    icon: `/images/branding/scouts-icon-purple.png`,
    titleImage: `/images/wall.jpg`,
    ogImage: `/images/wall.jpg`,
    twoColumnWall: false,
    cookiePolicy: true,
    introTag: `Welcome to 1st Erith Scout Group`,
    description: `1st Erith Scout Group are a diverse Group formed over 100 years ago, and form part of Bexley District Scouts.`,
    about: "",
    author: `@dalsoft`,
    blogItemsPerPage: 10,
    darkmode: false,
    switchTheme: true,
    navLinks: [
        {
            name: "HOME",
            url: "/",
        },
        {
            name: "OUR GROUPS",
            url: "/groups",
        },
        /*{
            name: "NEWS",
            url: "/blog",
        },*/
        {
            name: "HALL HIRE",
            url: "/hall-hire",
        },
        {
            name: "CONTACT",
            url: "/contact",
        },
    ],
    footerLinks: [
        {
            name: "PRIVACY POLICY",
            url: "/privacy-policy",
        },
    ],
    social: [
        {
            name: "Facebook",
            icon: "/images/Facebook.svg",
            url: "https://www.facebook.com/groups/1499568007001867/",
        },
    ],
    contact: {
        // leave empty ('') or false to hide form
        api_url: "https://dalsoft-website-backend-functions.azurewebsites.net/api/contact-us-form",
        description: "Ready for your next adventure or have questions? Get in touch and let us guide you every step of the way – we can’t wait to welcome you!",
        mail: "info@1sterithscoutgroup.co.uk",
        phone: "",
        address: "The Scout Hall\nCheviot Close\nBarnehurst\nDA7 6SP",
    },
    utterances: {
        repo: "",
        issueTerm: "title",
        label: "comment",
    }
}

const beforeContactFormSubmit = data => {
    // Code 0 - success
    // Code 1 - Name
    // Code 2 - Email
    // Code 3 - Message
    // Code 4 - Other
    const errors = []

    if (data.name.trim().length < 2) {
        errors.push({
            code: 1,
            message: "Enter a name",
        })
    }

    if (!data.email.match(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/)) {
        errors.push({
            code: 2,
            message: "Enter a valid email address",
        })
    }

    if (data.message.trim().length < 15) {
        errors.push({
            code: 3,
            message: "Enter a message with atleast 15 characters",
        })
    }

    if (errors.length > 0)
        return {
            result: false,
            errors: errors,
        }

    return {
        data: {
            name: data.name,
            email: data.email,
            message: data.message,
        },
        result: true,
    }
}

const contactFormSubmit = async (api, data) => {
    let res: any = await fetch(api, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    })

    res = await res.json()

    if (res.success) {
        return {
            result: true,
        }
    }
    return {
        result: false,
        ...res,
    }
}

const defaults = {
    disqus: null,
    twoColumnWall: true,
    darkmode: false,
    switchTheme: true,
    capitalizeTitleOnHome: true,
    cookiePolicy: false
}

Object.keys(defaults).forEach(item => {
    if (siteMetadata[item] === undefined) {
        siteMetadata[item] = defaults[item]
    }
})

export { siteMetadata, beforeContactFormSubmit, contactFormSubmit }
